import type { ReactNode } from 'react';

/**
 * Quiet, calm footer. Legal, docs, contact, copyright. Deliberately not
 * flashy — the CTA above it does the selling; this section is just
 * reassurance and legal navigation.
 */
export interface PublicFooterProps {
  tagline: string;
  linkGroups: readonly {
    heading: string;
    links: readonly { label: string; href: string }[];
  }[];
  copyright: string;
}

export function PublicFooter({ tagline, linkGroups, copyright }: PublicFooterProps): ReactNode {
  return (
    <footer
      style={{
        background: '#0f1117',
        color: '#94a3b8',
        borderTop: '1px solid rgba(255, 255, 255, 0.06)',
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '56px 24px 40px',
          display: 'grid',
          gridTemplateColumns: 'minmax(220px, 2fr) repeat(3, 1fr)',
          gap: 40,
        }}
      >
        <div>
          <div
            style={{
              color: '#f8fafc',
              fontWeight: 700,
              fontSize: 16,
              marginBottom: 12,
            }}
          >
            Vextura
          </div>
          <div style={{ fontSize: 13, lineHeight: 1.6, maxWidth: 260 }}>{tagline}</div>
        </div>
        {linkGroups.map((g) => (
          <div key={g.heading}>
            <div
              style={{
                color: '#e2e8f0',
                fontWeight: 600,
                fontSize: 12,
                textTransform: 'uppercase',
                letterSpacing: 0.6,
                marginBottom: 12,
              }}
            >
              {g.heading}
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'grid', gap: 8 }}>
              {g.links.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    style={{
                      color: '#94a3b8',
                      fontSize: 13,
                      textDecoration: 'none',
                    }}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div
        style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.06)',
          padding: '18px 24px',
          textAlign: 'center',
          fontSize: 12,
          color: '#64748b',
        }}
      >
        {copyright}
      </div>
    </footer>
  );
}
